import React, { useCallback, useState } from "react";
import { legalDocs, type LegalDocId } from "../data/legal";
import { LegalModal } from "./LegalModal";
export function Footer() {
  const [openId, setOpenId] = useState<LegalDocId | null>(null);
  const openDoc = legalDocs.find(doc => doc.id === openId) ?? null;
  const close = useCallback(() => setOpenId(null), []);
  return <footer className="border-t border-line bg-surface" data-id="element-69" data-mp="36n3chl6jxmt8">
      <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-4 px-6 py-8 text-sm text-muted md:flex-row" data-id="element-70" data-mp="3ugbs3c3g5mlg">
        <p className="font-serif text-cream" data-id="element-71" data-mp="36mskisw8wry">
          Mindset <span className="text-gold" data-id="element-72" data-mp="3ldamdcihtxib">Anti-Fragilidad</span>
        </p>
        <nav aria-label="Legal" className="flex items-center gap-6" data-id="element-73" data-mp="3qd6qdbr6xoxv">
          {legalDocs.map(doc => <button key={doc.id} type="button" onClick={() => setOpenId(doc.id)} className="whitespace-nowrap underline-offset-4 transition-colors duration-150 hover:text-cream hover:underline focus:outline-none focus-visible:text-cream focus-visible:underline" data-id="element-74" data-mp="29ynnprb9nhh6">
              {doc.label}
            </button>)}
        </nav>
        <p data-id="element-75" data-mp="3v89eog3s3xhe">© {new Date().getFullYear()} · Todos los derechos reservados</p>
      </div>
      <LegalModal doc={openDoc} onClose={close} data-id="element-76" data-mp="3q8wphopfqebn" />
    </footer>;
}